const WHATSAPP_NUMBER = "905428786499";
const WHATSAPP_DISPLAY = "+90 542 878 64 99";

export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`WhatsApp ${WHATSAPP_DISPLAY}`}
      data-testid="whatsapp-float"
      className="hidden lg:flex fixed bottom-6 right-6 rtl:right-auto rtl:left-6 z-50 items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-black/40 transition-transform duration-300 hover:scale-110 active:scale-95"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" aria-hidden="true">
        <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.114.552 4.176 1.6 5.999L4 29l8.2-1.548a11.94 11.94 0 0 0 3.803.62h.003C22.62 28.07 28 22.687 28 16.067 28 8.383 22.62 3 16.003 3zm0 21.9h-.002a9.9 9.9 0 0 1-3.42-.598l-.245-.09-4.868.919.925-4.742-.16-.246a9.86 9.86 0 0 1-1.51-5.24c0-5.49 4.47-9.96 9.96-9.96 2.66 0 5.16 1.037 7.04 2.918a9.9 9.9 0 0 1 2.915 7.05c0 5.49-4.47 9.96-9.96 9.96zm5.46-7.43c-.3-.15-1.77-.873-2.043-.973-.273-.1-.472-.15-.672.15-.2.3-.772.973-.947 1.173-.174.2-.35.224-.648.075-.3-.15-1.263-.465-2.404-1.483-.888-.792-1.487-1.77-1.662-2.07-.174-.3-.018-.462.13-.61.134-.134.3-.35.45-.524.15-.174.2-.3.3-.5.1-.2.05-.374-.025-.524-.075-.15-.672-1.62-.92-2.22-.242-.583-.487-.504-.672-.513l-.573-.01c-.2 0-.523.075-.797.374-.273.3-1.045 1.02-1.045 2.49 0 1.47 1.07 2.888 1.22 3.088.15.2 2.105 3.213 5.1 4.506.712.307 1.268.49 1.7.628.714.227 1.364.195 1.878.118.573-.085 1.77-.723 2.02-1.42.25-.698.25-1.297.174-1.42-.075-.124-.273-.2-.573-.35z"/>
      </svg>
    </a>
  );
}
